import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { PaymentStepData } from "../Models/PaymentStepData";
import { PaymentForm } from "../../../Models/Payment/PaymentForm";
import { Human } from "../../../Models/Human";


export class PaymentReturnInfoForCustomer extends Table
{
    constructor(payment: PaymentStepData, customer?: Human)
    {
        super();
        this.Class("payment-info-table");

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
            .AddRow("Kwota", payment.AmountAsString)
            .AddRow("Tytułem", payment.Title.value)

        switch (payment.Form.value)
        {
            case PaymentForm.Cash:
                break;

            case PaymentForm.Blik:
                this.AddRow("Na numer", customer?.Phone.value || "---")
                break;

            case PaymentForm.Crypto:
                const toPay = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Wartość", "Wyliczona z proporcji")
                    .AddRow("Z kwoty", payment.AmountAsString)
                    .AddRow("Do zwrotu", toPay + " " + payment.PaymentCurrency.value)
                    .AddRow("Kurs", `Z momentu wpłaty:\n${payment.ExchangeRate.value} PLN za 1 BTC`);
                if (!payment.AccountNumber.value)
                {
                    this.AddRow("Portfel", "❌ Nie został podany! Skontaktuj się z nami");
                }
                break;

            default:
            case PaymentForm.BankTransfer:
                this.AddRow("Na konto", customer?.BankAccountNumber.value || "⚠️ brak numeru konta")
                break;
        }

        this.AddRow("Termin", "do " + TimeUtils.FormattedDate(payment.Deadline.value))
    }
}
